// NGRX
import { Action } from '@ngrx/store';
// Models
import { Permission } from '../_models/permission.model';
import { PermissionWeb } from '../_models/permission.web.model';

export enum PermissionActionTypes {
    AllPermissionsRequested = '[Init] All Permissions Requested',
    AllPermissionsLoaded = '[Init] All Permissions Loaded'
}

export class AllPermissionsRequested implements Action {
    readonly type = PermissionActionTypes.AllPermissionsRequested;
}

export class AllPermissionsLoaded implements Action {
    readonly type = PermissionActionTypes.AllPermissionsLoaded;
    constructor(public payload: { permissions: PermissionWeb[] }) { }
}

export type PermissionActions = AllPermissionsRequested | AllPermissionsLoaded;
